// src/components/BlogIndexPage.js

import React, { useMemo } from 'react'; // useMemo needed inside component
import { Link } from 'react-router-dom';
import { parseMarkdown } from '../utils/markdownParser';
import SEO from './SEO';

// --- Webpack's require.context to import all markdown files ---
// This part can stay outside, as require.context is NOT a hook
const markdownContext = require.context('!!raw-loader!../blog-posts', false, /\.md$/);


const BlogIndexPage = () => { // <-- This is the functional component

  // --- Process the imported markdown files ONCE ---
  // MOVE the useMemo call and its logic INSIDE the component body
  const allPostsData = useMemo(() => {
    const posts = [];

    const filePaths = markdownContext.keys();

    filePaths.forEach(filePath => {
      const rawContent = markdownContext(filePath).default;

      const { metadata } = parseMarkdown(rawContent);

      if (metadata && metadata.slug) {
           posts.push({
              slug: metadata.slug,
              title: metadata.title || 'Untitled Post',
              date: new Date(metadata.date) || new Date(),
              description: metadata.description || '',
           });
      } else {
          console.warn(`Skipping post ${filePath}: Missing slug in frontmatter.`);
      }
    });

    posts.sort((a, b) => b.date - a.date);

    return posts;
  }, []); // Empty dependency array means this runs only once when the component mounts


  return (
    <div className="blog-index-container">
      <SEO
         title="Jimatly Blog - Malaysian Finance Articles"
         description="Explore articles and guides on personal finance, budgeting, investing, and taxes in Malaysia."
         canonical="https://www.jimatly.com/blog"
      />

      <h1>Jimatly Blog</h1>
      <p>Latest articles and guides on managing your finances in Malaysia.</p>

      {allPostsData.length > 0 ? (
        <div className="post-list">
          {allPostsData.map(post => (
            <div key={post.slug} className="post-list-item">
              <h2>
                <Link to={`/blog/${post.slug}`}>
                  {post.title}
                </Link>
              </h2>
              <p className="post-meta">
                {post.date.toLocaleDateString()}
                {post.author && ` by ${post.author}`}
              </p>
               {post.description && <p className="post-description">{post.description}</p>}
            </div>
          ))}
        </div>
      ) : (
        <p>No blog posts found yet.</p>
      )}
    </div>
  );
};

export default BlogIndexPage;